import { reportScopedError } from 'shared-utils/error'

export default defineNuxtPlugin(() => {
  if (!import.meta.client) {
    return
  }

  // A plugin must never take the whole app down: Nuxt would replace the rendered page with error.vue.
  try {
    const spotlight = usePointerSpotlight()

    spotlight.start()
  } catch (err) {
    const error = err as Error

    reportScopedError('plugins::spotlight', 'Initialization failed', error)
  }
})
